"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2407],{

/***/ 2407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CustomCode": function() { return /* binding */ CustomCode; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/esm/prism-async-light.js + 26 modules
var prism_async_light = __webpack_require__(5021);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/cjs/styles/prism/index.js
var prism = __webpack_require__(4283);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./context/ThemeContext.js
var ThemeContext = __webpack_require__(306);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./icons/copy.svg
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/compat_module.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path || (_path = /*#__PURE__*/compat_module.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/compat_module.createElement("path", {
    d: "M18 2H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H9V4h9v12zM3 15v-2h2v2H3zm0-5.5h2v2H3v-2zM10 20h2v2h-2v-2zm-7-1.5v-2h2v2H3zM5 22c-1.1 0-2-.9-2-2h2v2zm3.5 0h-2v-2h2v2zm5 0v-2h2c0 1.1-.9 2-2 2zM5 6v2H3c0-1.1.9-2 2-2z"
  })));
};

/* harmony default export */ var icons_copy = (SvgCopy);
;// CONCATENATED MODULE: ./icons/check-mark.svg
var check_mark_path, check_mark_path2;

function check_mark_extends() { check_mark_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_mark_extends.apply(this, arguments); }



var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/compat_module.createElement("svg", check_mark_extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), check_mark_path || (check_mark_path = /*#__PURE__*/compat_module.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  })), check_mark_path2 || (check_mark_path2 = /*#__PURE__*/compat_module.createElement("path", {
    d: "m19.77 4.93 1.4 1.4L8.43 19.07l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 4.93m0-2.83L8.43 13.44l-4.2-4.2L0 13.47l8.43 8.43L24 6.33 19.77 2.1z"
  })));
};

/* harmony default export */ var check_mark = (SvgCheckMark);
;// CONCATENATED MODULE: ./components/article/CopyButton.js





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function CopyButton(param) {
    var content = param.content;
    var ref = (0,compat_module.useState)(false), copied = ref[0], setCopied = ref[1];
    var copy = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return navigator.clipboard.writeText(content);
                    case 2:
                        setCopied(true);
                        setTimeout(function() {
                            setCopied(false);
                        }, 2000);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function copy() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "copy__container",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
            title: copied ? "Copied!" : "Copy to Clipboard",
            className: "copy__button",
            disabled: copied ? true : false,
            onClick: copy,
            children: copied ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(check_mark, {
                className: "copied"
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(icons_copy, {
                className: "copy"
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/article/CustomCode.js







function CustomCode(param) {
    var children = param.children;
    var dark = (0,compat_module.useContext)(ThemeContext/* ThemeContext */.N).dark;
    var language = children.props.className.replace("lang-", "");
    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: "code__container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CopyButton, {
                content: children.props.children
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(prism_async_light/* default */.Z, {
                style: dark ? prism/* nord */.Qn : prism.vs,
                language: language,
                children: children.props.children
            })
        ]
    }));
}


/***/ })

}]);